/* this directive adheres the default form behaviour
and adds $touched property! */
(function() {


    var ngModel = function() {
        return {
            restrict: 'A',
            require: '^?form',
            priority: 1000,
            link: function(scope, elem, attr, formCtrl) {
                if (formCtrl) {
                    function onBlurEvent() {
                        scope.$evalAsync(function(){ // without evalAsync this was executed in another angular tick...
                            formCtrl.$touched = true;
                            elem.off('blur', onBlurEvent);
                        });
                    }
                    if(!angular.isDefined(formCtrl.$touched)){
                        formCtrl.$touched = false;
                    }
                    elem.on('blur', onBlurEvent);

                    elem.on('$destroy', function() {
                        elem.off('blur', onBlurEvent);
                    });
                }
            }
        };
    }
    angular.module('app').directive('ngModel', ngModel);


}());